/*
document.addEventListener("DOMContentLoaded", function () {
  if (window.productCardLinks) {
    console.log("Liquid variable from window:", window.productCardLinks);
  } else {
    console.warn("Liquid variable not found.");
  }
});
*/
const showLinks = window.showProductCardLinks;
const interval = window.productCardLinksInterval;
resetNextPositionAndLinkIndex();
const repeat = window.productCardLinksRepeat;  //whether to repeat after the last one by starting over
// Function to load inline product card link elements
function loadProductCardLinks() {
  if (showLinks) {
    const elements = document.querySelectorAll('.product-grid-element');
    // window.productCardLinks is defined in main-collection

    if (elements.length >= window.nextPosition && window.link_index <= window.productCardLinks.length) { // only if nextPosition is greater than 0, otherwise we need to write a handling for inserting the first value before the first product-card
      
      const tmp = document.createElement('div');
      tmp.innerHTML = window.productCardLinks[window.link_index].trim();
      const customElement = tmp.firstChild;
      
      // Append custom element right after the selected card
      elements[window.nextPosition-1].after(customElement)
      window.nextPosition += interval;
      window.link_index += 1;
      if (window.link_index >= window.productCardLinks.length && repeat) {
        window.link_index = 0
      }
    }
  }
}

function resetNextPositionAndLinkIndex() {
  window.nextPosition = interval; // for first element we use interval, override it with a value for an offset
  window.link_index = 0
}